// import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { App } from "./App"
import { store } from "./app/store"
import { GoogleOAuthProvider } from "@react-oauth/google"
import "./index.css"

const container = document.getElementById("root")
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string

if (container) {
  const root = createRoot(container)

  root.render(
    // <StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </GoogleOAuthProvider>,
    // </StrictMode>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}
